












































































































































import { defineComponent, reactive, toRefs, computed, watch, onMounted, onBeforeUnmount, ref } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";
import MovieContentArea from "../../components/MovieContentArea.vue";
import PreviewImageArea from "../../components/PreviewImageArea.vue";
import PreviewHeaderLeftArea from "../../components/PreviewHeaderLeftArea.vue";
import { BaseSheet, QuestionImageDiscription } from "../../modules/student/ResultImagePreview"
import { MovieContent } from "../../modules/student/DigitalReport"

const PreviewImageTypeEnum = Common.PreviewImageTypeEnum;

export interface Data {
  initiarizedData: boolean
  base_sheet: BaseSheet
  nendo: string
  subject_name: string
  report_no: number
  base64QuestionImages: string[]
  base64CorrectImages: string[]
  movieContents: MovieContent[]
  direction: number
  mainAreaWidth: number
  mainAreaHeight: number
  selectedQuestionPageIdx: number
  selectedCorrectPageIdx: number
  keyCode: string
  pcHelpFields: any[]
  tabletHelpFields: any[]
  errors: string[]
  questionImageDiscriptions: QuestionImageDiscription[]
  previewImateTypes: number[]
  previewImageType: number
}

// @ts-ignore
export default defineComponent({
  components: {
    "alert-area": AlertArea,
    "movie-content-area": MovieContentArea,
    "preview-image-area": PreviewImageArea,
    "preview-header-left-area": PreviewHeaderLeftArea,
  },
  setup(props, context){

    const horizonQuestionImageAreaRef = ref<InstanceType<typeof PreviewImageArea>>();
    const horizonCorrectImageAreaRef = ref<InstanceType<typeof PreviewImageArea>>();

    const DirectionEnum = Common.DirectionEnum;

    /******************************
     * data
     ******************************/
    const state = reactive<Data>({
      initiarizedData: false,
      base_sheet: null,
      nendo: null,
      subject_name: null,
      report_no: null,
      base64QuestionImages: [],
      base64CorrectImages: [],
      movieContents: [],
      direction: DirectionEnum.Horizon,
      mainAreaWidth: 0,
      mainAreaHeight: 0,
      selectedQuestionPageIdx: 0,
      selectedCorrectPageIdx: 0,
      keyCode: null,
      pcHelpFields: [
        { key: "Ctrlキー + マウスホイール", img: require("@/assets/images/keyboard_Ctrl.png"), description: "拡大縮小" },
        { key: "Shiftキー + マウスホイール", img: require("@/assets/images/keyboard_Shift.png"), description: "左右にスクロール" },
        ],
      tabletHelpFields: [
        { key: "問題用紙または解答用紙上でピンチイン・ピンチアウト", description: "用紙の拡大縮小" },
      ],
      errors: [],
      questionImageDiscriptions: [],
      previewImateTypes: [],
      previewImageType: PreviewImageTypeEnum.None,
    });

    /************************************************************
     * メインエリアの高さを画面サイズに合わせてリサイズ
     * 初期表示・ウィンドウリサイズ時に発動
     ************************************************************/

    const adjustHeight = () => {
      const windowHeight = window.innerHeight;
      const windowWidth = window.innerWidth;
      const mainArea = document.getElementById("main-area");
      
      if(mainArea != null){
        state.mainAreaHeight = windowHeight - mainArea.offsetTop;
        state.mainAreaWidth = windowWidth;
        mainArea.style.width = state.mainAreaWidth + "px";
        mainArea.style.height = windowHeight - mainArea.offsetTop + "px";
      }
    };

    /************************************************************
     * 問題用紙・解答用紙を画面内に収まるようにリサイズ
     ************************************************************/

    const adjustSheet = () => {
      const questionArea = document.getElementById(`question-page-root-${state.direction}-${state.base_sheet.sheet_type}`);
      const correctArea = document.getElementById(`correct-page-root-${state.direction}-${state.base_sheet.sheet_type}`);
      const mainArea = document.getElementById("main-area");

      if(questionArea && mainArea){
        const areaW = questionArea.clientWidth - 16;
        const areaH = mainArea.clientHeight - 80;
        
        const scaleW = areaW / state.base_sheet.questionImageWidth;
        const scaleH = areaH / state.base_sheet.questionImageHeight;
        const scale = scaleW > scaleH ? scaleH * 100 : scaleW * 100;
        horizonQuestionImageAreaRef.value.inputScale = scale;
      }

      if(correctArea && mainArea){
        const areaW = correctArea.clientWidth - 16;
        const areaH = mainArea.clientHeight - 80;
        
        const scaleW = areaW / state.base_sheet.width;
        const scaleH = areaH / state.base_sheet.height;
        const scale = scaleW > scaleH ? scaleH * 100 : scaleW * 100;
        horizonCorrectImageAreaRef.value.inputScale = scale;
      }
    }

    /******************************
     * 問題用紙ページ切り替え時のemit
     ******************************/

    const questionSheetPageChanged = (idx: number) => {
      state.selectedQuestionPageIdx = idx;
    }

    /******************************
     * 模範解答ページ切り替え時のemit
     ******************************/

     const correctImagePageChanged = (idx: number) => {
      state.selectedCorrectPageIdx = idx;
    }

    /******************************
     * 問題用紙・模範解答表示切り替え
     ******************************/

     const changeImageType = (imageType: number) => {
      state.previewImageType = imageType;
    }

    /************************************************************
     * ピンチインアウトによる画面の拡大縮小禁止処理
     ************************************************************/

    const rootTouchmove = (e: TouchEvent) => {
      if(e.touches.length > 1){
        e.preventDefault();
      }
    }

    /************************************************************
     * キー押下
     ************************************************************/

     const keyDown = (e:KeyboardEvent) => {
      state.keyCode = e.key;
    }

    /************************************************************
     * キー入力による採点
     ************************************************************/

     const keyUp = (e: KeyboardEvent) => {
      state.keyCode = "";
    }

    /************************************************************
     * mounted
     ************************************************************/

    onMounted(async () => {

      if(!Common.studentSiteLoginCheck(context)){
        return;
      }

      context.root.$store.commit("setIsHeaderDisp", false);
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");

      await http.get(`/api/student/correct_image_preview?base_sheet_id=${context.root.$route.params.base_sheet_id}`).then(response => {
        state.base_sheet = new BaseSheet(response.data.base_sheet);
        state.subject_name = response.data.subject_name ? response.data.subject_name : "削除された科目";
        state.report_no = response.data.base_sheet.report_no;
        state.nendo = response.data.base_sheet.nendo;
        state.base64QuestionImages = response.data.base64_question_images;
        state.base64CorrectImages = response.data.base64_correct_images;
        state.movieContents = response.data.movie_contents;
        state.questionImageDiscriptions = response.data.question_image_discriptions;

        const previewImateTypes: number[] = [];
        if(state.movieContents.length > 0){
          previewImateTypes.push(PreviewImageTypeEnum.Movie);
        }
        if(state.base64CorrectImages.length > 0){
          previewImateTypes.push(PreviewImageTypeEnum.Correct);
        }
        if(state.base64QuestionImages.length > 0){
          previewImateTypes.push(PreviewImageTypeEnum.Question);
        }
        state.previewImateTypes = previewImateTypes;
        state.previewImageType = previewImateTypes.length > 0 ? previewImateTypes[0] : PreviewImageTypeEnum.None;
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`レポート情報の取得処理に失敗しました。レポート一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`レポート情報の取得処理に失敗しました。レポート一覧に戻ります。`);
        }
        window.history.back();
      });

      state.initiarizedData = true;
      context.root.$nextTick(() => {
        adjustHeight();
        adjustSheet();
      });
      window.addEventListener("resize", adjustHeight);
      window.addEventListener("orientationchange", adjustHeight);
      window.addEventListener("keyup", keyUp);
      window.addEventListener("keydown", keyDown);
      document.body.style.overflow = "hidden";

      context.root.$store.dispatch("hideOverlay");
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      window.removeEventListener("resize", adjustHeight);
      window.removeEventListener("orientationchange", adjustHeight);
      window.removeEventListener("keyup", keyUp);
      window.removeEventListener("keydown", keyDown);
      context.root.$store.commit("setIsHeaderDisp", true);
      document.body.style.overflow = "";
    });

    return {
      ...toRefs(state),
      horizonQuestionImageAreaRef,
      horizonCorrectImageAreaRef,
      PreviewImageTypeEnum,
      DirectionEnum,
      questionSheetPageChanged,
      correctImagePageChanged,
      changeImageType,
      keyDown,
      keyUp,
      rootTouchmove,
     };
  }
})
